import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CalService } from "../auth/cal.service";
import { AcdFormAttachmentList, ChangeRequest, Facility, FacilityAcd, UserList, userList } from "../interfaces/dashboard";
import { Observable, map, observable } from "rxjs";
import { AppConfig } from "./app-config.service";
import { commentsHistoryModel } from "../interfaces/dashboard";
@Injectable({
    providedIn: 'root'
})

export class AcdService {

    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
      };
    apiUrl = AppConfig.settings.apiUrl;
    mediaHttpOptions: any = { responseType: 'Blob', observe: 'response' };

    constructor(private http: HttpClient, private cal: CalService) {
    }
    
    public getGridData(reqbody: string) {
        return this.http.get<ChangeRequest[]>(
            `${this.apiUrl}ChangeRequest/GetChangeRequestsOf?changeRequestOf=${reqbody}`, this.httpOptions);
    }

    public getGridDataNew(typeOfRequest: any) {
        return this.http.post<ChangeRequest[]>(
          `${this.apiUrl}Dashboard/GetChangeRequestsOf?changeRequestOf=${typeOfRequest}`, this.httpOptions);
    }
    
    public onBehalfOfUsers() {
        return this.http.get<userList[]>(
            `${this.apiUrl}ChangeRequest/GetOnBehalfOfUsers`, this.httpOptions);
    }

    public getPriorityList() {
        return this.http.get<any>(
            `${this.apiUrl}RequestPriority`, this.httpOptions
        );
    }
    
    getAllInfo() {
        return this.http.get<any>(
            `${this.apiUrl}ChangeRequest/GetNewAcdFormDetails?active=true`, this.httpOptions
        );
    }

    getDefineInfo(crId :  any) {
        return this.http.get<any>(
            `${this.apiUrl}ChangeRequest/GetDefineAcdFormDetails?changeRequestID=${crId}&active=true`, this.httpOptions
        );
    }
    public getFacilityList() {
        return this.http.get<any>(
            `${this.apiUrl}Facility?active=true`, this.httpOptions
        );
    }

    public submitAcd(reqData: any) {
        return this.http.post<any>(
            `${this.apiUrl}ChangeRequest/CreateChangeRequest`, reqData, this.httpOptions);
    }

    public addComment(reqData: any) {
        return this.http.post<any>(
            `${this.apiUrl}ChangeRequest/CreateChangeRequestComment`, reqData, this.httpOptions);
    }

    public getComment(crno: number,cid : number) {
        return this.http.get<any>(
            `${this.apiUrl}ChangeRequest/GetChangerequestCommentById?CRId=${crno}&CID=${cid}`, this.httpOptions);
    }

    public ViewAcdAttachmentList(reqData:any){

        return this.http.get<AcdFormAttachmentList>(
          `${this.apiUrl}ChangeRequest/GetAcdAttachmentListById?ChangeRequestID=${reqData}`, this.httpOptions); 

    }

    public viewAcd(reqData: any) {
        return this.http.get<any>(
            `${this.apiUrl}ChangeRequest/GetChangerequestById?ChangeRequestID=${reqData}`, this.httpOptions);
    }

    public getUsers() {
        return this.http.get<userList[]>(
            `${this.apiUrl}ChangeRequest/GetAssignToUsers`, this.httpOptions);
    }

    public changeStatus(statusid:number,crid:number) {
        const reqdata={}
        return this.http.post<any>(
            `${this.apiUrl}ChangeRequest/UpdateChangeRequeststatus?CRid=${crid}&statusid=${statusid}`,reqdata, this.httpOptions);
    }

    public changePriority(priorityid:number,crid:number) {
        const reqdata={}
        return this.http.post<any>(
            `${this.apiUrl}ChangeRequest/UpdateChangeRequestpriority?CRid=${crid}&priorityid=${priorityid}`,reqdata, this.httpOptions);
    }

    public getLoadHistory() {
        return this.http.get<any>(`https://emdm-api-dev-cvx.azurewebsites.net/api/getLoadHistory`, this.httpOptions);
    }

    public getCommentsHistory(reqId: any) {
        return this.http.get<commentsHistoryModel>(`${this.apiUrl}ChangeRequest/GetCommentHistory?ChangeRequestID=${reqId}`, this.httpOptions);
    }

    public getStatus(){
        return this.http.get<any>(`${this.apiUrl}ChangeRequest/GetStatus?active=true`,this.httpOptions);
    }

    public assignCrToUser(reqdata : any){
        return this.http.put<any>(
            `${this.apiUrl}ChangeRequest/AssignChangeRequest`,reqdata, this.httpOptions);
    }

    // public setCrDetails(reqData :any){
    //     this.http.get<ChangeRequest>(
    //         `${this.apiUrl}ChangeRequest/GetChangerequestById?ChangeRequestID=${reqData}`, this.httpOptions).subscribe((data)=>{
    //         sessionStorage.setItem('crDetails', JSON.stringify(data));
    //       })
    //       return true;
    // }

    public cancelRequest(reqData:any){
        return this.http.post<any>(`${this.apiUrl}ChangeRequest/CreateCancelOrCompleteChangeRequestComment`,reqData,this.httpOptions);
    }

    public EditComment(reqData : any){
        return this.http.post<any>(
            `${this.apiUrl}ChangeRequest/UpdateChangeRequestComment`,reqData,this.httpOptions
        );
    }

    public UpdateCR(reqData : any,crid :any){
        return this.http.put<any>(
            `${this.apiUrl}ChangeRequest/UpdateChangeRequest/${crid}`,reqData,this.httpOptions
        );
    }

    public submitAcdSummary(crno: any,priorityId : number) {
        return this.http.put<any>(
            `${this.apiUrl}ChangeRequest/SubmitRequest/${crno}?requestPriorityid=${priorityId}`, this.httpOptions
        );
    }

    public getHistorySearch(payload: any) {
      return this.http.post<any>(`${this.apiUrl}Dashboard/SearchChangeRequestsHistory`,payload, this.httpOptions);
    }

    public generateLoadFiles(crNo:any): Observable<HttpResponse<any>> {
      const url = `${this.apiUrl}GenerateLoadFiles/DownloadGenerateLoadFiles`;
      const params = new HttpParams().set('crid', String(crNo));

      return this.http.post(url, null, {
        params,
        observe: 'response'
      });
    }

     getWholeChangeRequest(crid: number) {
        return this.http.get<any>(`${this.apiUrl}ChangeRequest/GetChangeRequest?ChangeRequestID=${crid}&active=true`, this.httpOptions);
     }
}
